import UpdateOrder from './UpdateOrder'
export default UpdateOrder
